import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { Header } from "components/Header";
import "./App.css";
import { Footer } from "components/Footer";

function App() {
  return (
    <Router>
      <Header />
      <div className="routes-container">
        <AppRoutes />
      </div>
      <Footer />
    </Router>
  );
}

export default App;
